<template>
  <div class="flex" v-if="small">
    <label class="ang-form-label mr-2" :class="{ 'text-dark': !disabled }"
      >{{ label }}
    </label>
    <span :data-tippy-content="tip">
      <svg
        width="15"
        height="15"
        viewBox="0 0 25 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="cursor-pointer"
      >
        <circle cx="12.5" cy="12.5" r="12" stroke="#591144"></circle>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11.3631 10.4319C11.4121 10.2466 11.4852 10.0821 11.5819 9.93765C11.6826 9.78971 11.8095 9.66812 11.9632 9.57245C12.1162 9.48034 12.3075 9.43197 12.5413 9.43197C12.7362 9.43197 12.9028 9.46597 13.0433 9.53119L13.0463 9.53245C13.1931 9.59371 13.3152 9.68271 13.4139 9.79962C13.5126 9.91186 13.5875 10.0498 13.6357 10.2127L13.6364 10.2148C13.6897 10.3788 13.7167 10.5585 13.7167 10.7545C13.7167 11.013 13.6647 11.2518 13.5627 11.4693C13.4633 11.6918 13.3332 11.906 13.1734 12.1096C13.0166 12.3161 12.847 12.5177 12.6646 12.7142C12.4787 12.9146 12.303 13.123 12.1377 13.3388C11.9756 13.5523 11.8392 13.7796 11.7292 14.0193C11.6218 14.2598 11.5686 14.5233 11.5686 14.8086V15.723H13.0843V14.9078C13.0843 14.7302 13.1334 14.5504 13.235 14.3674C13.3399 14.1785 13.4709 13.9855 13.627 13.7901C13.7845 13.5877 13.9575 13.3776 14.146 13.1597C14.3375 12.9382 14.5139 12.7057 14.6744 12.4635C14.836 12.2145 14.9716 11.9499 15.081 11.6699C15.1923 11.3849 15.2477 11.0795 15.2477 10.7545C15.2477 10.4056 15.1979 10.0667 15.0984 9.73819C14.9981 9.40721 14.8394 9.11223 14.6223 8.85404C14.4038 8.59411 14.1223 8.3885 13.7799 8.2364C13.434 8.07765 13.0202 8 12.5413 8C12.197 8 11.8888 8.04409 11.618 8.13386C11.3554 8.21752 11.1228 8.33041 10.9208 8.47317C10.7252 8.61003 10.5569 8.76968 10.4186 8.94972C10.2881 9.12639 10.178 9.30617 10.0888 9.48908C9.87849 9.91291 9.75874 10.4025 9.72755 10.956L9.72266 11.0429H11.2495L11.2578 10.97C11.2778 10.7962 11.3129 10.6165 11.3631 10.4319Z"
          fill="#591144"
        ></path>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11.5971 18.1891H13.1127V16.6808H11.5971V18.1891Z"
          fill="#591144"
        ></path>
      </svg>
    </span>
  </div>
  <div class="flex" v-else>
    <label
      class="text-xs font-bold mr-2 mt-1"
      :class="{ 'text-dark': !disabled }"
      >{{ label }}
    </label>
    <span class="pb-1" :data-tippy-content="tip">
      <svg
        width="25"
        height="25"
        viewBox="0 0 25 25"
        fill="none"
        class="cursor-pointer"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="12.5" cy="12.5" r="12" stroke="#591144" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11.3631 10.4319C11.4121 10.2466 11.4852 10.0821 11.5819 9.93765C11.6826 9.78971 11.8095 9.66812 11.9632 9.57245C12.1162 9.48034 12.3075 9.43197 12.5413 9.43197C12.7362 9.43197 12.9028 9.46597 13.0433 9.53119L13.0463 9.53245C13.1931 9.59371 13.3152 9.68271 13.4139 9.79962C13.5126 9.91186 13.5875 10.0498 13.6357 10.2127L13.6364 10.2148C13.6897 10.3788 13.7167 10.5585 13.7167 10.7545C13.7167 11.013 13.6647 11.2518 13.5627 11.4693C13.4633 11.6918 13.3332 11.906 13.1734 12.1096C13.0166 12.3161 12.847 12.5177 12.6646 12.7142C12.4787 12.9146 12.303 13.123 12.1377 13.3388C11.9756 13.5523 11.8392 13.7796 11.7292 14.0193C11.6218 14.2598 11.5686 14.5233 11.5686 14.8086V15.723H13.0843V14.9078C13.0843 14.7302 13.1334 14.5504 13.235 14.3674C13.3399 14.1785 13.4709 13.9855 13.627 13.7901C13.7845 13.5877 13.9575 13.3776 14.146 13.1597C14.3375 12.9382 14.5139 12.7057 14.6744 12.4635C14.836 12.2145 14.9716 11.9499 15.081 11.6699C15.1923 11.3849 15.2477 11.0795 15.2477 10.7545C15.2477 10.4056 15.1979 10.0667 15.0984 9.73819C14.9981 9.40721 14.8394 9.11223 14.6223 8.85404C14.4038 8.59411 14.1223 8.3885 13.7799 8.2364C13.434 8.07765 13.0202 8 12.5413 8C12.197 8 11.8888 8.04409 11.618 8.13386C11.3554 8.21752 11.1228 8.33041 10.9208 8.47317C10.7252 8.61003 10.5569 8.76968 10.4186 8.94972C10.2881 9.12639 10.178 9.30617 10.0888 9.48908C9.87849 9.91291 9.75874 10.4025 9.72755 10.956L9.72266 11.0429H11.2495L11.2578 10.97C11.2778 10.7962 11.3129 10.6165 11.3631 10.4319Z"
          fill="#591144"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11.5971 18.1891H13.1127V16.6808H11.5971V18.1891Z"
          fill="#591144"
        />
      </svg>
    </span>
  </div>
</template>
<script>
import tippy from "tippy.js";
export default {
  data() {
    return {};
  },
  props: ["label", "tip", "disabled", "small"],
  mounted() {
    console.log("test");
    tippy("[data-tippy-content]");
  },
};
</script>
